// extracted by mini-css-extract-plugin
export default {"block":"_e","select":"af","empty":"bf","open":"cf","error":"df","options":"ef","selectActive":"ff","ornament":"gf"};